import { Fragment } from 'react';

import ImageMapUploader from '../../containers/ImageMapUploader';
import ImageMapList from '../../containers/ImageMapList';

const ImageMapsPage = () => (
    <Fragment>
        <ImageMapUploader />
        <ImageMapList id="imageMaps" />
    </Fragment>
);

export default ImageMapsPage;
